import React, { Children, PropsWithChildren, ReactElement, useEffect } from 'react';
import styled from '@emotion/styled';
import { IoTicketOutline } from '@react-icons/all-files/io5/IoTicketOutline';
import { BucketLogData } from '@bucketplace/bucket-log';

import { EditorPlaceholder } from '../../components/EditorPlaceholder';
import { useEditorInfoContext } from '../../contexts';
import { useCouponContext } from '../../contexts';
import { useEditorNode } from '../../hooks';
import { DocumentPath } from '../../types';

export type CouponThemes = 'theme-1' | 'custom';
export interface CouponProps {
  /** 장바구니 쿠폰틀 id들 */
  id: string;
  /** 상품쿠폰틀 id들 */
  productCouponMoldId?: string;
  /** 쿠폰틀 조회 후 focus를 children으로 변경하기 위해 사용 */
  canChildFocus?: boolean;
  path: DocumentPath;
  logData?: BucketLogData;
}

export function Coupon(props: PropsWithChildren<CouponProps>): ReactElement {
  const { id: cartCouponMoldId, productCouponMoldId = '', children, path, canChildFocus, logData } = props;

  const { displayMode, onSelect } = useEditorNode([...path, 0]);
  const { onClick } = useCouponContext();
  const { onSendLog } = useEditorInfoContext();

  const hasChildren = Children.count(children) > 0;

  useEffect(() => {
    if (canChildFocus) {
      onSelect();
    }
  }, [canChildFocus]);

  if (!hasChildren) {
    return (
      <EditorPlaceholder
        icon={<IoTicketOutline />}
        message="쿠폰을 추가해주세요."
      />
    );
  }

  const handleCouponClick = async (): Promise<void> => {
    if (displayMode === 'edit') {
      alert(`쿠폰 아이디: ${cartCouponMoldId} ${productCouponMoldId} \n에디터에서는 쿠폰을 다운로드할 수 없습니다.`);
      return;
    }

    if (logData) {
      onSendLog?.(logData);
    }
    await onClick?.(
      cartCouponMoldId.replace(/ /g, '').split(','),
      productCouponMoldId.replace(/ /g, '').split(','),
    );
  };

  return (
    <CouponWrapper onClick={handleCouponClick}>
      { children }
    </CouponWrapper>
  );
}

const CouponWrapper = styled.div`
  cursor: pointer;
`;
